<template>
  <div class="mt-4 p-4 bg-white border rounded-lg min-vh-25">
    <div v-if="!response && !error" class="text-center text-muted py-5">
      <span>Send a request to see the response here.</span>
    </div>
    <div v-else>
      <SfeTabs default-tab="body" variant="shadowButton">
        <SfeTabList>
          <SfeTabTrigger value="body">Body</SfeTabTrigger>
          <SfeTabTrigger value="headers">Headers</SfeTabTrigger>
        </SfeTabList>
        <SfeTabContent value="body">
          <SfeLabel class="mb-1">{{ error ? 'Error' : 'Body' }}</SfeLabel>
          <pre class="bg-light p-3 rounded overflow-auto response-body-fixed-height">{{ error ? errorString(error) : prettyJson(response?.data) }}</pre>
        </SfeTabContent>
        <SfeTabContent value="headers">
          <SfeLabel class="mb-1">Headers</SfeLabel>
          <div class="table-responsive">
            <SfeTable>
              <SfeTableHeader>
                <SfeTableRow>
                  <SfeTableHead>Header</SfeTableHead>
                  <SfeTableHead>Value</SfeTableHead>
                </SfeTableRow>
              </SfeTableHeader>
              <SfeTableBody>
                <SfeTableRow v-for="(value, key) in getHeaders" :key="key">
                  <SfeTableCell><code>{{ value[0] ?? '' }}</code></SfeTableCell>
                  <SfeTableCell><code>{{ value[1] ?? '' }}</code></SfeTableCell>
                </SfeTableRow>
              </SfeTableBody>
            </SfeTable>
          </div>
        </SfeTabContent>
      </SfeTabs>
    </div>
  </div>
</template>

<script>
export default {
  props: ['response', 'error'],
  computed: {
    errorStatus() {
      // Try to extract status from error object if available
      if (!this.error) return null
      if (this.error.status) return this.error.status
      if (this.error.response && this.error.response.status) return this.error.response.status
      return null
    },
    getHeaders() {
      return this.getHeadersFromResponseOrError()
    }
  },
  methods: {
    prettyJson(obj) {
      if (!obj) return ''
      try {
        return JSON.stringify(obj, null, 2)
      } catch {
        return String(obj)
      }
    },
    errorString(err) {
      if (!err) return ''
      if (typeof err === 'string') return err
      if (err.data) return JSON.stringify(err.data, null, 2)
      if (err.response && err.response.data) return JSON.stringify(err.response.data, null, 2)
      return JSON.stringify(err, null, 2)
    },
    // Helper to get headers from response or error
    getHeadersFromResponseOrError() {
      if (this.response && this.response.headers) return this.response.headers
      if (this.error && this.error.headers) return this.error.headers
      if (this.error && this.error.response && this.error.response.headers) return this.error.response.headers
      return {}
    }
  }
}
</script>

<style scoped>
.response-body-fixed-height {
  max-height: 400px;
  min-height: 150px;
  height: 400px;
  overflow-y: auto;
  font-size: 1rem;
  line-height: 1.5;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;
}
.response-headers-table {
  width: 100%;
  background: #fff;
  border-collapse: separate;
  border-spacing: 0;
}
.response-headers-table th, .response-headers-table td {
  padding: 0.75rem 1rem;
  border: 1px solid #e9ecef;
  background: #fff;
  font-size: 1rem;
  vertical-align: middle;
}
.response-headers-table th {
  background: #f8f9fa;
  font-weight: 600;
}
.response-headers-table code {
  background: none;
  color: #212529;
  font-size: 1rem;
}
</style>
